'use client';

import {motion} from 'framer-motion';
import useTopStyle from '../../utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from '../../animation/heroVariants';
import spanVariants from '../../animation/spanVariants';
import PlatformAnim from './PlatformAnim/PlatformAnim';

const PlatformHero = (props) => {
  const ref = useTopStyle(72);
  const {title,highlight,text} = props

  return (
    <motion.section
      className='platform-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='content'>
          <h2 className='title'>
            {title}
            <motion.span
              className='highlight'
              initial={'hidden'}
              animate={'visible'}
              transition={{
                duration: 0.8,
                delay: 0.8,
                ease: 'easeInOut'
              }}
              variants={spanVariants}
            >
              {highlight}
            </motion.span>
          </h2>
          <p className='text'>{text}</p>
          <BookBtn />
        </div>
        <div className='design'>
          <PlatformAnim />
        </div>
      </div>
    </motion.section>
  );
};

export default PlatformHero;

